import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "vue-app/components/MainLayout/MainLayout.vue";
import { dashboardRoutes } from "./assets/js/app/dashboard/routes";
import { homepageRoutes } from "vue-app/router/routesHomepage";
import { settingsRoutes } from "./assets/js/app/settings/routes";
import { onsiteRoutes } from "vue-app/router/routesOnsite";
import { ordersRoutes } from "vue-app/router/routesOrders";
import { engagementRoutes } from "./assets/js/app/engagements/routes";
import { permissionsRoutes } from "./assets/js/app/permissions/routes";
import { customFlowsRoutes } from "vue-app/router/routesCustomFlows";
import { newsletterRoutes } from "vue-app/router/routesNewsletter";
import { productsRoutes } from "vue-app/router/routesProducts";
import { inboxRoutes } from "vue-app/router/routesInbox";
import { segmentationRoutes } from "vue-app/router/routesSegmentation";
import { customersRoutes, crmRoutes } from "vue-app/router/routesCustomers";
import { pushNewsletterRoutes } from "vue-app/router/routesPushNewsletter";
import { productCategoriesRoutes } from "vue-app/router/routesProductCategories";
import { readyFlowsRoutes } from "vue-app/router/routesReadyFlows";
import { liveEventsRoutes } from "vue-app/router/routesLiveEvents";
import { routesAccount } from "vue-app/router/routesAccount";
import { usePostHog } from "vue-app/composables/usePostHog";

const routes = [
  {
    path: "",
    component: MainLayout,
    children: [
      ...homepageRoutes,
      ...dashboardRoutes,
      ...inboxRoutes,
      ...settingsRoutes,
      ...onsiteRoutes,
      ...ordersRoutes,
      ...pushNewsletterRoutes,
      ...engagementRoutes,
      ...readyFlowsRoutes,
      ...permissionsRoutes,
      ...customFlowsRoutes,
      ...newsletterRoutes,
      ...productsRoutes,
      ...segmentationRoutes,
      ...customersRoutes,
      ...crmRoutes,
      ...productCategoriesRoutes,
      ...liveEventsRoutes,
      ...routesAccount,
    ],
  },
  {
    name: "PageConversation",
    path: "/app/standalone/conversation",
    component: () => import("vue-app/pages/PageConversation/PageConversation.vue"),
  },
  {
    path: "/app/standalone/inbox",
    component: () => import("vue-app/pages/PageInbox.vue"),
  },
  {
    name: "PageBranding",
    path: "/app/branding",
    component: () => import("vue-app/pages/PageBranding/PageBranding.vue"),
    meta: {
      skipGlobalLoader: true,
    },
  },
  {
    name: "PageIpValidation",
    path: "/app/ip-validation",
    component: () => import("vue-app/pages/PageIpValidation/PageIpValidation.vue"),
  },
  {
    name: "PagePingdom",
    path: "/app/pingdom",
    component: () => import("vue-app/pages/PagePingdom.vue"),
  },
  {
    name: "PageAccessBlocked",
    path: "/app/blocked",
    component: () => import("vue-app-new/pages/PageAccessBlocked/PageAccessBlocked.vue"),
  },
  {
    name: "PageActivationFlow",
    path: "/app/activation-flow",
    component: () => import("vue-app-new/pages/PageActivationFlow/PageActivationFlow.vue"),
    meta: { skipGlobalLoader: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/app/404",
  },
  {
    path: "/app/404",
    component: () => import("vue-app/pages/Page404Error.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

usePostHog();

export default router;
